import { render, staticRenderFns } from "./DocumentTagSummary.vue?vue&type=template&id=553a3dfa&scoped=true"
import script from "./DocumentTagSummary.vue?vue&type=script&lang=js"
export * from "./DocumentTagSummary.vue?vue&type=script&lang=js"
import style0 from "./DocumentTagSummary.vue?vue&type=style&index=0&id=553a3dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a3dfa",
  null
  
)

export default component.exports